import { Dialog, DialogContent } from '@mui/material';
import React from 'react';
import './voyageModal.css';
import CreateEdit from '../PolicyProduct/RiskFactor/Voyage/CreateEdit';

function VoyageCreateModal({ handleClose, productId, setNewValue }) {
  return (
    <Dialog fullWidth={true} maxWidth={'lg'} open={true} onClose={handleClose}>
      <DialogContent className="modalContainer">
        <CreateEdit
          setNewValue={setNewValue}
          closeCreateEditForm={handleClose}
          voyageEditDatas={null}
          editStatus={false}
          productId={productId}
        />
      </DialogContent>
    </Dialog>
  );
}

export default VoyageCreateModal;
